module.exports = __webpack_public_path__ + "85feae55b301b1ad9d38d35ef19adffb.png";